export const CONTROL_INFO_TYPES_SUBMITTING = 'CONTROL_INFO_TYPES_SUBMITTING';
export const CONTROL_INFO_TYPES_FETCHING = 'CONTROL_INFO_TYPES_FETCHING';
export const CONTROL_INFO_TYPES_SUBMIT_ERROR =
  'CONTROL_INFO_TYPES_SUBMIT_ERROR';
export const CONTROL_INFO_TYPES_FETCH_ERROR = 'CONTROL_INFO_TYPES_FETCH_ERROR';
export const CONTROL_INFO_TYPES_SUBMIT_SUCCESS =
  'CONTROL_INFO_TYPES_SUBMIT_SUCCESS';
export const CONTROL_INFO_GET_TYPES = 'CONTROL_INFO_GET_TYPES';
export const CONTROL_INFO_TYPES_CLEAR_ERROR_SUCCESS =
  'CONTROL_INFO_CLEAR_ERROR_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/householdCategoricalTypes/types.js